module.exports = __webpack_public_path__ + "img/thumbnail_WesternLowlandGorilla_m_albino.d5e72732.png";